import { Category, Partner } from "#/api/partnersShowcase/partnersShowcase";

export function handlerDOM(): void {
  const results: any = document.getElementById("res");
  const input: any = document.getElementById("categories-partners");
  results.style.display = "none";
  input.value = "";
}
export function triggerOnInput(value: any) {
  let results: any = document.getElementById("res");
  if (value.target.value.length >= 1) {
    results.style.display = "flex";
  } else {
    results.style.display = "none";
  }
}

export function returnTextFilterPartner(items: Partner[] | undefined): string {
  if (items) {
    return items.length > 0 ? "Parceiros" : "Parceiros: Sem Sugestões";
  }
  return "";
}

export function returnTextFilterCategory(
  items: Category[] | undefined
): string {
  if (items) {
    return items.length > 0 ? "Categorias" : "Categorias: Sem Sugestões";
  }
  return "";
}
